import { render } from "./DriveAddFiles.vue?vue&type=template&id=20a0c67a&scoped=true&ts=true"
import script from "./DriveAddFiles.vue?vue&type=script&lang=ts"
export * from "./DriveAddFiles.vue?vue&type=script&lang=ts"

import "./DriveAddFiles.vue?vue&type=style&index=0&id=20a0c67a&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a0c67a"]])

export default __exports__